import api from './api';

/**
 * Upload a file to Supabase Storage via the backend /upload proxy.
 * @param file   The File object to upload
 * @param folder One of: "notices" | "documents" | "quotations" | "bookings" | "tickets" | "pl-statements" | "facilities" | "group-buys"
 * @returns      The public URL string of the uploaded file
 */
export const uploadFile = async (file: File, folder: string): Promise<string> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('folder', folder);
    const res = await api.post('/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data.url as string;
};
